import React from 'react';
import { Button, Stack } from '@mui/material';
import GoogleIcon from '@mui/icons-material/Google';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const RegisterSocialsComponent = ({ type }) => {
  const handleRegister = (provider) => {
    // Replace with actual OAuth logic or redirect
    console.log(`Register with ${provider}`);
  };

  return (
    <Stack spacing={2} direction="column " alignItems="center">
      <Button
        variant="contained"
        color="primary"
        startIcon={<GoogleIcon />}
        onClick={() => handleRegister('Google')}
        className='w-full'
      >
        {type === "login" ? "Login with Google" : "Register with Google"}         
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<FacebookIcon />}
        onClick={() => handleRegister('Facebook')}
        className='w-full mt-3 mb-3'
        style={{marginTop: "12px", marginBottom: "12px"}}
      >
        {type === "login" ? "Login with Facebook" : "Register with Facebook"}         
      </Button>
      <Button
        variant="contained"
        color="primary"
        startIcon={<LinkedInIcon />}
        onClick={() => handleRegister('LinkedIn')}
        className='w-full'
      >
        {type === "login" ? "Login with Linkedin" : "Register with Linkedin"}         
      </Button>
    </Stack>
  );
};

export default RegisterSocialsComponent;
